module.exports = __webpack_public_path__ + "static/media/history-mobile.f6db592d.svg";